<template>
    <div class="wrapper">
        <div class="clickout" @click="cancel"></div>
        <div class="cont-wrapper">
            <div class="content-box animated animatedFadeInUp fadeInUp">
                <p>{{ title }}</p>
                <button
                    class="del"
                    :class="{ ok: buttonType }"
                    @click="buttonAction"
                >
                    {{ buttonMsg }}
                </button>
                <button class="cancel" @click="cancel">Cancel</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['title', 'buttonMsg'],
  computed: {
    buttonType() {
      if (this.buttonMsg === 'Ok') {
        return true;
      } return false;
    },
  },
  methods: {
    buttonAction() {
      this.$emit('buttonAction');
    },

    cancel() {
      this.$emit('closeModel');
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 24px;
}
/* Animation */

@keyframes fadeInUp {
    from {
        transform: translate3d(0, 40px, 0);
    }

    to {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }
}

@-webkit-keyframes fadeInUp {
    from {
        transform: translate3d(0, 40px, 0);
    }

    to {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }
}

.animated {
    animation-duration: 0.4s;
    animation-fill-mode: both;
    -webkit-animation-duration: 0.4s;
    -webkit-animation-fill-mode: both;
}

.animatedFadeInUp {
    opacity: 0;
}

.fadeInUp {
    opacity: 0;
    animation-name: fadeInUp;
    -webkit-animation-name: fadeInUp;
}

.cont-wrapper {
    width: 100vw;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
}

.clickout {
    z-index: 40;
    top: 0;
    left: 0;
    position: absolute;
    width: 100vw;
height: 100%;
    background: rgba(44, 44, 44, 0.4);
}
.content-box {
    z-index: 50;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    border-radius: 20px;
    background: var(--surface);
    height: 310px;
    width: min(calc(100vw - 60px), 500px);
}
.content-box p {
    width: 200px;
    margin-top: 0px;
}

button {
    width: min(calc(100vw - 50px - 35%), 300px);
    height: 63px;
    font-weight: 500;
    font-size: 20px;
    border: none;
    border-radius: var(--border-radius);
}
.del {
    background-color: var(--error);
    margin-bottom: 13px;
}
.ok {
    background-color: var(--success);
}
.cancel {
    background-color: transparent;
}
</style>
